import { useState } from "react";
import { Button } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import logo from "../../assets/static/images/sn-logo.png"

import useUser from "../../hooks/useUser";
import { logout } from "../../services/auth";
import LoginModal from "../loginModal/LoginModal";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

import LoadingModal from "../loadingModal/LoadingModal";

import perfil from "../../assets/static/images/perfil-color.png";

import "../../assets/styles/Header.css"

const Header = () => {
  const [show, setShow] = useState(false);
  const user = useUser();
  const navigate = useNavigate();
  const { loading } = useSelector(state => state.data);
  const location = useLocation();

  const handleOpen = () => setShow(true);
  const handleClose = () => setShow(false);

  const handleLogout = () => {
    logout();
    navigate("/");
  }

  return (
    <nav className="header">
      <div className="header-logo">
        <Link to="/">
          <div className="logo-container">
            <img src={logo} alt="logo-sn" width="70" />
            <span className="header-line admin-line"></span>
            <div className="logo-text"><span>Modo</span> <b>Excursión</b></div>
          </div>
        </Link>
      </div>

      <div className="header-admin">
        {!user ? (
          <div className="header-admin-container" onClick={handleOpen}>
            <span className="header-admin-text">Admin</span>
            <span className="header-line"></span>
            <img src={perfil} alt="perfil-icon" />
          </div>
        ) : (
          <div className="logout">
            <span className="header-username">{user.username}</span>
            <span className="header-line admin-line"></span>
            {location?.pathname !== "/admin" ?
              <Button variant="dark" className="me-3" onClick={() => navigate("/admin")}>Panel de administración</Button>
              : ""}
            <Button variant="danger" onClick={handleLogout}>Cerrar Sesión</Button>
          </div>
        )
        }
      </div>
      {show ? <LoginModal show={show} handleClose={handleClose} /> : ""}
      {loading ? <LoadingModal show={loading} /> : ''}
    </nav>
  )
}

export default Header;